import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';


const begambleawareImg = '/images/begambleaware.png';
const gamblingCommissionImg = '/images/gambling_commission_logo.png';
const gamcareImg = '/images/gamcare.png';
const gamstopImg = '/images/gamstop_logo.png';
const ageRestrictionImg = '/images/18+.png';

const Footer = () => {
  return (
    <footer className="bg-regal-dark border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div itemScope itemType="https://schema.org/Organization">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/favicon.webp" alt="Regal Play" className="h-10 w-10 object-contain" itemprop="logo" />
              <h3 className="text-xl font-bold text-white" itemprop="name">Regal Play</h3>
            </div>
            <p className="text-gray-400 leading-relaxed" itemprop="description">
              Your trusted guide to the best UK online casinos. We connect players with premium gaming experiences and exclusive bonuses.
            </p>
            <p>Email: <span itemprop="email">info@regal-play.com</span></p>
            <p>Phone: <span itemprop="telephone">+44 0544 403 303</span></p>
            <div itemprop="address" itemScope itemType="https://schema.org/PostalAddress">
              <p>Address: <span itemprop="addressLocality">London</span>, <span itemprop="addressCountry">United Kingdom</span></p>
            </div>
          </div>

         


          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/guides" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/news" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/reviews" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/slots" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Slots
                </Link>
              </li>
            </ul>
          </div>




          <div>
            <h3 className="text-white font-bold mb-4">Legal links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Responsible Gaming
                </Link>
              </li>
            </ul>
          </div>



          <div>
            <h3 className="text-white font-bold mb-4">Responsible Gaming</h3>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-8">
              <div className="flex items-center">
                <a
                    href="https://www.begambleaware.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="BeGambleAware - Responsible Gambling"
                      src={begambleawareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamblingcommission.gov.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="UK Gambling Commission"
                      src={gamblingCommissionImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamcare.org.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="GamCare - Gambling Support"
                      src={gamcareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamstop.co.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="Gamstop - Self-Exclusion"
                      src={gamstopImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <img
                    className="h-[60px] w-auto object-contain"
                    alt="18+ Age Restriction"
                    src={ageRestrictionImg}
                />
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Regal Play. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm text-center md:text-right">
              Domain: regal-play.com
            </p>
          </div>
          <div className="mt-6 pt-6 border-t border-gray-800">
            <p className="text-gray-500 text-xs leading-relaxed text-center">
              Regal Play operates as an independent review and comparison platform. Certain links featured on our website are affiliate partnerships, which means we may receive compensation when visitors click through or register through these links. This compensation structure does not influence our editorial content, reviews, or ratings—we maintain complete editorial independence. All visitors must be 18 years or older. We promote responsible gambling practices and encourage players to seek support at BeGambleAware.org if needed. All offers are subject to individual casino terms and conditions.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

